import React from 'react'
import styled from '@emotion/styled'
import { Typography } from 'src/components/atoms/Typography'

const ChapterName = ({ children }) => {
  return <ChapterNameStyle as="p">{children}</ChapterNameStyle>
}

const ChapterNameStyle = styled(Typography)`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: 2.5px;
  text-align: left;
  color: #22475d;
`
export default ChapterName
